import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { EyeType } from "types/tests";
import { ConfigSaveButtonState } from "types/uiTypes";
import { NotificationEventType } from "@/types/notificationTypes";

export interface UIState {
  newTestExtension: "/new-test-ui" | null;
  showOrgDetailInResults: boolean;
  configSaveButtonState: ConfigSaveButtonState | null;
  isDoTheOtherEyeButtonPressed: boolean;
  isSkipVirtualAssistantModalOpen: boolean;
  isSkipCalibrationModalOpen: boolean;
  isVABatchDownloadViewOpen: boolean;
}

const initialState: UIState = {
  newTestExtension: null,
  showOrgDetailInResults: false,
  configSaveButtonState: null,
  isDoTheOtherEyeButtonPressed: false,
  isSkipVirtualAssistantModalOpen: false,
  isSkipCalibrationModalOpen: false,
  isVABatchDownloadViewOpen: false,
};

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    setNewTestExtension(state, action: PayloadAction<"/new-test-ui">) {
      state.newTestExtension = action.payload;
    },
    setShowOrgDetailsInResults(state, action: PayloadAction<boolean>) {
      state.showOrgDetailInResults = action.payload;
    },
    navigateToNewTestPage(_state) {},
    navigateToSettingsPage(_state, _action: PayloadAction<string | null>) {},
    pressTerminateTestButton(_state) {},
    pressDoAnotherTestButton(_state) {},
    pressTestOtherEyeButton(_state, _action: PayloadAction<EyeType>) {},
    pressTurnOffDeviceButton(_state) {},
    updateConfigSaveButtonState(state, action: PayloadAction<ConfigSaveButtonState | null>) {
      state.configSaveButtonState = action.payload;
    },
    toggleDoTheOtherEyeButtonState(state, action: PayloadAction<boolean>) {
      state.isDoTheOtherEyeButtonPressed = action.payload;
    },
    openSkipVirtualAssistantModal(state) {
      state.isSkipVirtualAssistantModalOpen = true;
    },
    closeSkipVirtualAssistantModal(state) {
      state.isSkipVirtualAssistantModalOpen = false;
    },
    openSkipCalibrationModal(state) {
      state.isSkipCalibrationModalOpen = true;
    },
    closeSkipCalibrationModal(state) {
      state.isSkipCalibrationModalOpen = false;
    },
    openVABatchDownloadView(state) {
      state.isVABatchDownloadViewOpen = true;
    },
    closeVABatchDownloadView(state) {
      state.isVABatchDownloadViewOpen = false;
    },
    confirmSkipVirtualAssistant(_state) {
      // Handled in saga
    },
    confirmSkipCalibration(_state) {
      // Handled in saga
    },
    trackNotificationChoice(
      _state,
      _action: PayloadAction<{
        type: NotificationEventType;
        notificationId: string;
        actionId?: string;
      }>,
    ) {
      // Handled in saga
    },
  },
});

export const {
  setNewTestExtension,
  navigateToNewTestPage,
  setShowOrgDetailsInResults,
  navigateToSettingsPage,
  pressTerminateTestButton,
  pressDoAnotherTestButton,
  pressTestOtherEyeButton,
  pressTurnOffDeviceButton,
  updateConfigSaveButtonState,
  toggleDoTheOtherEyeButtonState,
  openSkipVirtualAssistantModal,
  closeSkipVirtualAssistantModal,
  openSkipCalibrationModal,
  closeSkipCalibrationModal,
  confirmSkipVirtualAssistant,
  confirmSkipCalibration,
  openVABatchDownloadView,
  closeVABatchDownloadView,
  trackNotificationChoice,
} = uiSlice.actions;

export default uiSlice.reducer;
